export default "a-default";



//////////////////
// WEBPACK FOOTER
// ./src/mod1.js
// module id = 1
// module chunks = 0